module.exports = __webpack_public_path__ + "img/flang_car.f3e615b2.png";